import React from 'react';
import { useStaticQuery, graphql } from 'gatsby'
import PropTypes from 'prop-types';

import * as styles from 'src/uglib_styles/faqList.module.css'

function FAQList ({category}) {

    const results = useStaticQuery(graphql`
        query FAQListQuery {
            faqs: allNodeFaq(sort: {title: ASC}) {
            edges {
                node {
                title
                body {
                    value
                }
                drupal_id
                drupal_internal__nid
                path {
                    alias
                }
                relationships {
                    field_faq_category {
                    name
                    }
                }
                }
            }
            }
        }
    `)

    let data = results.faqs.edges;

    // Filter by category
    if (category) {
        data = data.filter((faq) => {
            return faq.node.relationships.field_faq_category.name === category;
        })
    }

    function get_anchor_name(faq) {
        return faq.node.drupal_internal__nid;
    }

    const faq_links = data.map((faq) => {
        return (
            <li id={get_anchor_name(faq)}>
                <h2>
                    {faq.node.title}
                </h2>
                <div dangerouslySetInnerHTML={{__html: faq.node.body.value}} />
            </li>
        )
    })
    
    return (<>
        <ul className={styles.faq_list}>
            {faq_links}
        </ul>
    </>);
       
}

FAQList.propTypes = {
	category: PropTypes.string,
}

FAQList.defaultProps = {
    category: "General"
}

export default FAQList